<script lang="ts">
  import { ModuleSetting } from "module/store/ModuleSettings";
  import { stores } from "module/store/SettingsStore";
  import {
    SearchMode,
    type CallActionCallback,
    type SearchResultItem,
  } from "./SearchControllers";
  import { resultItems } from "./resultitems";

  let {
    tooltips = "LEFT",
    embedded = false,
    results = [],
    selectedIndex,
    selectedAction,
    searchMode,
    callAction,
  }: {
    tooltips?: "LEFT" | "RIGHT" | "OFF";
    embedded?: boolean;
    results: SearchResultItem[];
    selectedIndex: number;
    selectedAction?: string;
    searchMode: SearchMode;
    callAction: CallActionCallback;
  } = $props();

  let density = stores[ModuleSetting.SEARCH_DENSITY];
  let tooltipModeSetting = stores[ModuleSetting.SEARCH_TOOLTIPS];

  let tooltipMode = $tooltipModeSetting;

  let resultList: HTMLElement;

  const ResultComponent = $derived(resultItems[searchMode]);

  $effect(() => {
    if (embedded) {
      return;
    }

    if (resultList?.children[selectedIndex]) {
      const selected = resultList.children[selectedIndex] as HTMLElement;
      selected.scrollIntoView({ block: "nearest" });
      if (tooltipMode !== "off" && selected.dataset?.tooltip && !embedded) {
        game.tooltip.activate(selected);
      } else {
        game.tooltip.deactivate();
      }
    } else {
      if (tooltipMode !== "off") {
        game.tooltip.deactivate();
      }
    }
  });

  function getId(resultItem?: SearchResultItem) {
    if (!resultItem) {
      return undefined;
    }

    if ("id" in resultItem.item && "uuid" in resultItem.item) {
      return resultItem.item.id + resultItem.item.uuid;
    }
    return resultItem.item.id;
  }
</script>

<ul
  class="quick-insert-result density-{$density}"
  tabindex="-1"
  bind:this={resultList}
  data-tooltip-direction={tooltips}
  role="listbox"
  aria-activedescendant={`result_${getId(results[selectedIndex])}`}
>
  {#each results as resultItem, index (getId(resultItem))}
    <ResultComponent
      selected={selectedIndex === index}
      density={$density}
      {resultItem}
      {selectedAction}
      {callAction}
    ></ResultComponent>
  {/each}
</ul>
